import React from "react";
import { useSelector } from "react-redux";
import User from "src/containers/user/NameOrEmail";
import { getGroupCreator } from "src/reducers";
import type { Nullable } from "src/ts-types";
import { AppState } from "src/types";

interface Props {
  id: number;
}

const Creator = ({ id }: Props): Nullable<React.ReactElement> => {
  const creator = useSelector(({ app }: { app: AppState }) =>
    getGroupCreator(app, id),
  );

  if (!creator) return null;

  return <User uid={creator} />;
};

export default Creator;
